/* ═══════════════════════════════════════════════════════════
   KLOBÚK — Main JavaScript (Shopify Integration)
   ═══════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  // ─── Header Scroll Behavior ───
  const header = document.querySelector('.header');
  const announcement = document.querySelector('.announcement-bar');

  if (header) {
    const announcementHeight = announcement ? announcement.offsetHeight : 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;

      if (header.classList.contains('transparent')) {
        if (currentScroll > 80) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      }

      if (announcement) {
        if (currentScroll > announcementHeight) {
          header.style.top = '0';
          announcement.style.transform = 'translateY(-100%)';
        } else {
          header.style.top = announcementHeight + 'px';
          announcement.style.transform = 'translateY(0)';
        }
      }
    });
  }

  // ─── Mobile Menu ───
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('active');
      mobileMenu.classList.toggle('active');
      document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
      if (!mobileMenu.classList.contains('active')) {
        mobileMenu.querySelectorAll('.mobile-menu-group.active').forEach(g => g.classList.remove('active'));
      }
    });

    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        hamburger.classList.remove('active');
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    });

    mobileMenu.querySelectorAll('.mobile-menu-parent').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('.mobile-menu-group');
        const wasActive = group.classList.contains('active');
        mobileMenu.querySelectorAll('.mobile-menu-group.active').forEach(g => g.classList.remove('active'));
        if (!wasActive) group.classList.add('active');
      });
    });
  }

  // ─── Mega Menu ───
  const shopLink = document.querySelector('[data-mega-menu]');
  const megaMenu = document.querySelector('.mega-menu');

  if (shopLink && megaMenu) {
    let timeout;

    function showMega() {
      clearTimeout(timeout);
      megaMenu.classList.add('active');
      if (header) header.classList.add('mega-active');
    }

    function hideMega() {
      megaMenu.classList.remove('active');
      if (header) header.classList.remove('mega-active');
    }

    shopLink.addEventListener('mouseenter', showMega);

    shopLink.addEventListener('mouseleave', () => {
      timeout = setTimeout(hideMega, 200);
    });

    megaMenu.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
    });

    megaMenu.addEventListener('mouseleave', hideMega);
  }

  // ─── Cart Drawer ───
  const cartTriggers = document.querySelectorAll('[data-cart-open]');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartClose = document.querySelector('.cart-close');

  function openCart() {
    cartOverlay && cartOverlay.classList.add('active');
    cartDrawer && cartDrawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartOverlay && cartOverlay.classList.remove('active');
    cartDrawer && cartDrawer.classList.remove('active');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  });

  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      if (hamburger && mobileMenu) {
        hamburger.classList.remove('active');
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      }
    }
  });

  // Bind qty buttons rendered server-side
  document.querySelectorAll('.cart-drawer-body .cart-qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      const qty = parseInt(btn.dataset.qty, 10);
      updateCartItem(key, qty);
    });
  });

  // ─── Shopify AJAX Cart ───
  function updateCartCount(count) {
    document.querySelectorAll('.bag-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        const body = document.querySelector('.cart-drawer-body');
        if (!body) return;

        let footer = document.querySelector('.cart-drawer-footer');
        if (!footer) {
          footer = document.createElement('div');
          footer.className = 'cart-drawer-footer';
          footer.innerHTML = '<div class="cart-shipping-bar">Complimentary shipping on orders over $4,000 MXN</div><div class="cart-total"><span>Subtotal</span><span></span></div><a href="/checkout" class="cart-checkout-btn">Checkout</a>';
          document.querySelector('.cart-drawer').appendChild(footer);
        }

        if (cart.item_count === 0) {
          body.innerHTML = `
            <div class="cart-empty">
              <p style="font-family:var(--font-heading);font-size:20px;color:var(--black);margin-bottom:8px;">Your bag is empty.</p>
              <p style="color:var(--gray);">Time to find your next statement piece.</p>
              <a href="/collections/all" class="btn btn-primary" style="margin-top:24px;">Shop Now</a>
            </div>`;
          if (footer) footer.style.display = 'none';
          return;
        }

        let html = '';
        cart.items.forEach(item => {
          const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          html += `
            <div class="cart-item" data-key="${item.key}">
              <img src="${item.featured_image.url || item.image}" alt="${item.title}" class="cart-item-image" style="width:80px;height:100px;object-fit:cover;">
              <div>
                <div class="cart-item-name">${item.product_title}</div>
                ${variantTitle ? `<div class="cart-item-variant">${variantTitle}</div>` : ''}
                <div class="cart-item-qty">
                  <button type="button" class="cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}">&minus;</button>
                  <span>${item.quantity}</span>
                  <button type="button" class="cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
                </div>
              </div>
              <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
            </div>`;
        });
        body.innerHTML = html;

        if (footer) {
          footer.style.display = '';
          const totalEl = footer.querySelector('.cart-total span:last-child');
          if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        }

        body.querySelectorAll('.cart-qty-btn').forEach(btn => {
          btn.addEventListener('click', () => {
            const key = btn.dataset.key;
            const qty = parseInt(btn.dataset.qty, 10);
            updateCartItem(key, qty);
          });
        });
      });
  }

  function updateCartItem(key, quantity) {
    const cartItem = document.querySelector(`.cart-item[data-key="${key}"]`);
    if (cartItem) cartItem.classList.add('loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(r => r.json())
      .then(() => refreshCartDrawer());
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ─── Product Form Submit (AJAX Add to Cart) ───
  const productForm = document.querySelector('#ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = productForm.querySelector('.add-to-bag');
      const formData = new FormData(productForm);

      btn.disabled = true;
      const originalText = btn.textContent;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(r => {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(() => {
          btn.textContent = 'ADDED TO YOUR BAG';
          btn.style.background = 'var(--gold)';
          refreshCartDrawer();
          setTimeout(() => {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
            openCart();
          }, 1200);
        })
        .catch(() => {
          btn.textContent = 'ERROR — TRY AGAIN';
          btn.style.background = '#c0392b';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        });
    });
  }

  // ─── Variant Selection ───
  const variantData = document.querySelector('[type="application/json"][data-product-variants]');
  if (variantData) {
    try {
      const variants = JSON.parse(variantData.textContent);
      const optionSelectors = document.querySelectorAll('.color-swatch, .size-option');

      optionSelectors.forEach(selector => {
        selector.addEventListener('click', () => {
          const index = parseInt(selector.dataset.optionIndex, 10);
          const value = selector.dataset.value;

          // Update active state for same option group
          const parent = selector.closest('.color-swatches, .size-options');
          if (parent) {
            parent.querySelectorAll('.color-swatch, .size-option').forEach(s => {
              s.classList.remove('active');
              if (s.classList.contains('size-option')) {
                s.style.background = 'transparent';
                s.style.color = '';
              }
            });
            selector.classList.add('active');
            if (selector.classList.contains('size-option')) {
              selector.style.background = 'var(--black)';
              selector.style.color = 'var(--white)';
            }
          }

          // Update label
          const label = selector.closest('.product-option').querySelector('.product-option-label');
          if (label) {
            const baseName = label.textContent.split('—')[0].trim();
            label.textContent = baseName + ' — ' + value;
          }

          // Find matching variant
          const selectedOptions = [];
          document.querySelectorAll('.product-option').forEach(optGroup => {
            const active = optGroup.querySelector('.color-swatch.active, .size-option.active');
            if (active) selectedOptions.push(active.dataset.value);
          });

          const match = variants.find(v =>
            v.options.every((opt, i) => selectedOptions[i] === undefined || opt === selectedOptions[i])
          );

          if (match) {
            document.getElementById('ProductVariantId').value = match.id;
            const priceEl = document.getElementById('ProductPrice');
            if (priceEl) {
              let priceHtml = '';
              if (match.compare_at_price && match.compare_at_price > match.price) {
                priceHtml += `<s style="color:var(--gray);margin-right:8px;">${formatMoney(match.compare_at_price)}</s>`;
              }
              priceHtml += formatMoney(match.price);
              priceEl.innerHTML = priceHtml;
            }

            const addBtn = document.querySelector('.add-to-bag');
            if (addBtn) {
              addBtn.disabled = !match.available;
              addBtn.textContent = match.available ? 'Add to Bag' : 'Sold Out';
            }

            // Update main image if variant has image
            if (match.featured_image) {
              const mainImg = document.getElementById('ProductMainImage');
              if (mainImg) {
                mainImg.style.opacity = '0';
                setTimeout(() => {
                  mainImg.src = match.featured_image.src;
                  mainImg.style.opacity = '1';
                }, 200);
              }
            }
          }
        });
      });
    } catch (e) { /* no variant data */ }
  }

  // ─── Accordion ───
  document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.parentElement;
      const wasActive = item.classList.contains('active');

      item.closest('.accordion').querySelectorAll('.accordion-item').forEach(i => {
        i.classList.remove('active');
      });

      if (!wasActive) {
        item.classList.add('active');
      }
    });
  });

  // ─── Product Gallery ───
  const mainImage = document.querySelector('.product-main-image');
  const thumbnails = document.querySelectorAll('.product-thumbnail');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) {
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.src = thumb.dataset.fullSrc || thumb.src;
          mainImage.style.opacity = '1';
        }, 200);
      }
    });
  });

  // ─── Scroll Animations ───
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.fade-in').forEach(el => {
    observer.observe(el);
  });

  // ─── Smooth Scroll ───
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const targetId = anchor.getAttribute('href');
      if (targetId === '#') return;
      e.preventDefault();
      const target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ─── Wishlist Toggle ───
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('wishlisted')) {
        btn.classList.remove('wishlisted');
        btn.innerHTML = '<span class="heart-icon">&#9825;</span> Add to Wishlist';
      } else {
        btn.classList.add('wishlisted');
        btn.innerHTML = '<span class="heart-icon">&#9829;</span> Saved to Wishlist';
      }
    });
  });

});
